import React, { useState } from 'react';
import { Form } from 'semantic-ui-react';
import PropTypes from 'prop-types';

import FilterButton from '../../../components/Button/FilterButton';
import { CardContainer, Title, Header, Footer, Main } from '../styles';

export default function Filter(props) {
  const { malls, onClick, title } = props;
  const [mall, setMall] = useState('');
  const [active, setActive] = useState('');

  return (
    <CardContainer>
      <Header>
        <Title>{title}</Title>
      </Header>
      <Main>
        <Form>
          <Form.Group>
            <Form.Select
              label="Centro Comercial"
              placeholder="Todos"
              options={malls}
              width={6}
              value={mall}
              onChange={(e, { value }) => setMall(value)}
            />
            <Form.Select
              label="Activo"
              placeholder="Todos"
              options={[
                { key: 0, text: 'Todos', value: '' },
                { key: 1, text: 'Si', value: true },
                { key: 2, text: 'No', value: false }
              ]}
              width={6}
              value={active}
              onChange={(e, { value }) => setActive(value)}
            />
          </Form.Group>
        </Form>
      </Main>
      <Footer>
        <FilterButton
          className="btnFilter"
          onClick={() => onClick(mall, active)}
        />
      </Footer>
    </CardContainer>
  );
}

Filter.propTypes = {
  malls: PropTypes.array,
  onClick: PropTypes.func,
  title: PropTypes.string
};
